module.exports = __webpack_public_path__ + "static/RUdeskSlide2-ff2b15cbf1d98e47c7a0f92a78aa5dcf.png";